import React from 'react'

import './SubHeading.css'

function SubHeading({subHeading}) {
  return (
    <div className='sub-heading'>
      <h2>{subHeading}</h2>
    </div>
  )
}

export default SubHeading
